import {NgModule} from '@angular/core';
import {ManagementComponent} from './management.component';
import {SharedProviderModule} from '../shared/shared.module';
import {VivoModule} from '../vivo/vivo.module';
import {LinkingModule} from '../linking/linking.module';
import {NgbAccordionModule, NgbTabsetModule} from '@ng-bootstrap/ng-bootstrap';
import {AppVersionComponent} from './app-version/app-version.component';
import {FormDataModule} from '../form-data/form-data.module';

@NgModule({
  imports: [
    FormDataModule,
    LinkingModule,
    SharedProviderModule,
    NgbTabsetModule,
    NgbAccordionModule,
    VivoModule
  ],
  declarations: [ManagementComponent, AppVersionComponent],
  exports: [ManagementComponent]
})
export class ManagementModule {
}
